
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators/twitch/[recordId]",
      function () {
        return require("private-next-pages/creators/twitch/[recordId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creators/twitch/[recordId]"])
      });
    }
  